import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, type PaginationProps, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PaginationSrAlertMessage } from './detail/PaginationSrAlertMessage.tsx';

const PaginationSimpleList = styled.ul`
  color: rgba(0, 0, 0, 0.88);
  font-weight: bolder;
  font-size: 14px;
  line-height: 1;
  list-style: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  > li.body {
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slash {
    /* margin-inline: 6px; */
    font-weight: 300;
  }
  .pagination-button[aria-disabled='true'] {
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
`;

export interface IPaginationSimpleProps
  extends Pick<
    PaginationProps,
    'onChange' | 'total' | 'current' | 'pageSize'
  > {}

/**
 * Componente di Paginazione Semplice.
 */
export function PaginationSimple(props: Readonly<IPaginationSimpleProps>) {
  const { total = 0, pageSize = 10 } = props;
  const { t } = useTranslation();
  const totalPages = Math.ceil(total / pageSize);
  const current = totalPages === 0 ? 0 : (props.current ?? 1);

  return (
    <nav aria-label={t('common.paginazione.aria-label', 'Paginazione')}>
      <PaginationSimpleList>
        <li>
          <Button
            className="pagination-button"
            aria-label={t(
              'common.paginazione.precedente',
              'Vai alla pagina precedente',
            )}
            type="text"
            size="small"
            icon={<LeftOutlined aria-hidden="true" />}
            aria-disabled={current <= 1}
            onClick={() => {
              if (current > 1) {
                props.onChange?.(current - 1, pageSize);
              }
            }}
          />
        </li>
        <li className="body">
          <PaginationSrAlertMessage
            currentPage={current}
            totalPages={totalPages}
          />
          <Space aria-hidden="true" size={6}>
            <b>{current}</b>
            <span className="slash">/</span>
            <b>{totalPages}</b>
          </Space>
        </li>
        <li>
          <Button
            className="pagination-button"
            aria-label={t(
              'common.paginazione.successiva',
              'Vai alla pagina successiva',
            )}
            type="text"
            size="small"
            icon={<RightOutlined aria-hidden="true" />}
            aria-disabled={current >= totalPages}
            onClick={() => {
              if (current < totalPages) {
                props.onChange?.(current + 1, pageSize);
              }
            }}
          />
        </li>
      </PaginationSimpleList>
    </nav>
  );
}
